/**
 * Versions saved by the legacy app (2018-20) can have no page list (pdfPageNumbers).
 * The page navigator and note templates read its last name unguarded and threw, and
 * promoting such a version wrote `pdfPageNumbers: undefined`, which Firestore rejects
 * after the PDF has already been replaced (21 Oct 2026). Same pattern as workNoteOf.
 */

/** The stored page list, or pages numbered 1..count when it is missing or empty. */
export function pageNamesOr(pages, count) {
    if (Array.isArray(pages) && pages.length) {
        return pages;
    }
    const n = Number.isInteger(count) && count > 0 ? count : 0;
    return Array.from({ length: n }, (_, i) => ({ id: i, name: `${i + 1}` }));
}

/** The label of the page at a 1-based position (what the page box shows), or the number when the list has none. */
export function pageLabelAt(pages, page) {
    const entry = Array.isArray(pages) ? pages[page - 1] : null;
    return entry && entry.name ? entry.name : `${page}`;
}

/** Name of the last page in a page list, or `fallback` when there is no list. */
export function lastPageName(pages, fallback = '') {
    return Array.isArray(pages) && pages.length && pages[pages.length - 1] ? pages[pages.length - 1].name : fallback;
}

/**
 * The page list promote writes to the live show. A stored empty list is rebuilt 1..N
 * from the PDF on the next load by healPageLabels (page-labels.js).
 */
export function labelsToRestore(pages) {
    return Array.isArray(pages) ? pages : [];
}



// WEBPACK FOOTER //
// ./src/lib/page-names.js